import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import EUserType from 'enums/userTypes';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IWorkerCreateRequestBody from 'services/httpClient/requests/worker/IWorkerCreateRequestBody';
import ICreateWorkerResponse from 'services/httpClient/responses/worker/ICreateWorkerResponse';

import { workerActions } from '../index';
import { IWorkerCreateRequestAction } from '../reducers/create/request';

function* create(action: PayloadAction<IWorkerCreateRequestAction>) {
  try {
    const body: IWorkerCreateRequestBody = {
      intervention_partnership_id:
        action.payload.data.intervention_partnership_id,
      email: action.payload.data.email,
      locale: action.payload.data.locale,
      // team_id: action.payload.data.teamId,
      accountant:
        action.payload.data.userType === EUserType.Accountant || undefined,
      admin: action.payload.data.userType === EUserType.Admin || undefined,
      firstname: action.payload.data.firstName || undefined,
      lastname: action.payload.data.lastName || undefined,
      technician:
        action.payload.data.userType === EUserType.Technician || undefined,
      company_details: action.payload.data.company_details,
      user_management: action.payload.data.user_management,
      invoice_permission: action.payload.data.invoice_permission,
      all_interventions: action.payload.data.all_interventions,
    };

    const { data }: AxiosResponse<ICreateWorkerResponse> = yield call(
      httpClient.post,
      'rik/v1/workers/create',
      body,
    );

    yield put(
      workerActions.createSuccess({
        worker: {
          ...data,
          type: action.payload.data.userType,
          fullName: `${data.firstname} ${data.lastname}`,
        },
      }),
    );
    action.payload.functions.handleClose();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(workerActions.createFailure());
  }
}

export default create;
